// unified-slideshow.js
document.addEventListener('DOMContentLoaded', function() {
  // Handle both video slideshow and image banner slideshow
  const videoContainers = document.querySelectorAll('.slideshow.banner.video-banner');
  const imageSliders = document.querySelectorAll('.custom-slideshow');

  // Process video slideshow containers
  videoContainers.forEach((slideContainer) => {
    if (!slideContainer || slideContainer.dataset.videoSlideshowInitialized === 'true') return;
    slideContainer.dataset.videoSlideshowInitialized = 'true';
    initSlideshow(slideContainer, slideContainer, slideContainer.querySelectorAll('.slideshow__slide'), false);
  });

  // Process image banner slideshows
  imageSliders.forEach((slider) => {
    if (slider.dataset.slideshowInitialized === 'true') return;
    slider.dataset.slideshowInitialized = 'true';
    const slideContainer = slider.querySelector('.custom-slider');
    const slides = slider.querySelectorAll('.custom-slideshow__slide');
    if (!slideContainer || slides.length < 1) return;
    initSlideshow(slider, slideContainer, slides, true);
  });

  function initSlideshow(slider, slideContainer, slides, isImageBanner) {
    if (!slideContainer || slides.length < 1) return;

    // Only apply drag/swipe if there's more than 1 slide
    const enableDragSwipe = slides.length > 1;

    let currentIndex = 0;
    let isScrolling;
    // Prevent scroll handler from fighting programmatic navigation (image banner only)
    let navLockActive = false;
    let navLockTarget = -1;
    let navLockTimeout = null;

    // Shared drag/swipe state for both desktop and mobile
    let isDragging = false;
    let hasDragged = false;
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let velocity = 0;
    let totalMovement = 0; // Track total pointer movement distance
    let currentSlideWrapper = null; // Track which slide wrapper was clicked
    let isTouchDevice = false; // Track if current interaction is touch-based
    let isVerticalScroll = false; // Track if user is scrolling vertically
    let suppressTapNavigation = false; // Set when vertical/page scroll is detected
    let gestureActive = false;
    let gesturePageScrollStart = 0;
    let gestureStartTime = 0;
    let tapNavigationAllowed = false; // Only true for intentional taps (blocks ghost clicks)
    let suppressClicksUntil = 0; // Timestamp guard against synthetic clicks after drag/swipe
    let activePointerId = null;
    let dragAxis = null;
    let dragStartTarget = null;
    let lastPointerX = 0;
    let lastPointerTime = 0;

    const AXIS_LOCK_THRESHOLD = 10;
    const MAX_TAP_DURATION_MS = 350;
    const GHOST_CLICK_SUPPRESS_MS = 450;

    // Click vs drag threshold (kept device-specific to preserve CTA taps)
    const getClickDragThreshold = () => {
      return isTouchDevice ? 12 : 10;
    };

    const recordGestureStart = () => {
      gestureActive = true;
      gesturePageScrollStart = window.scrollY || document.documentElement.scrollTop || 0;
      gestureStartTime = Date.now();
      suppressTapNavigation = false;
      tapNavigationAllowed = false;
    };

    const clearGestureState = () => {
      gestureActive = false;
    };

    const pageScrolledDuringGesture = () => {
      if (!gestureActive) return false;
      const currentScroll = window.scrollY || document.documentElement.scrollTop || 0;
      return Math.abs(currentScroll - gesturePageScrollStart) > 4;
    };

    const shouldBlockBannerNavigation = () => {
      return (
        hasDragged ||
        suppressTapNavigation ||
        isVerticalScroll ||
        pageScrolledDuringGesture() ||
        Date.now() < suppressClicksUntil
      );
    };

    const suppressClicksBriefly = (ms = GHOST_CLICK_SUPPRESS_MS) => {
      suppressClicksUntil = Date.now() + ms;
      suppressTapNavigation = true;
      setTimeout(() => {
        if (Date.now() >= suppressClicksUntil) {
          suppressTapNavigation = false;
        }
      }, ms);
    };

    const qualifiesAsTap = (totalMove) => {
      if (shouldBlockBannerNavigation()) return false;
      if (totalMove > getClickDragThreshold()) return false;
      if (Date.now() - gestureStartTime > MAX_TAP_DURATION_MS) return false;
      return true;
    };

    const autoplayEnabled = (slideContainer?.dataset?.autoplay || 'false') === 'true';
    const rotateOnceInViewport = (slideContainer?.dataset?.rotateOnceInViewport || 'false') === 'true';
    const pauseAutoplayOnInteraction = (slideContainer?.dataset?.pauseAutoplayOnInteraction || 'false') === 'true';
    const advanceOnVideoEnd = (slideContainer?.dataset?.advanceOnVideoEnd || 'false') === 'true';
    const speedSec = parseInt(slideContainer?.dataset?.speed || '6', 10);
    const speedMs = Math.max(1000, speedSec * 1000);
    const paginationEnabled = (slideContainer?.dataset?.pagination || 'true') === 'true';
    const visibleThreshold = Math.min(1, Math.max(0, parseFloat(slideContainer?.dataset?.visibleThreshold || '0.2')));

    const getAutoplayRotationsInView = () =>
      parseInt(slideContainer?.dataset?.autoplayRotationsInView || '0', 10);

    const resetAutoplayRotationsInView = () => {
      if (rotateOnceInViewport) {
        slideContainer.dataset.autoplayRotationsInView = '0';
      }
    };

    const canAutoplayRotate = () => {
      if (!rotateOnceInViewport || !autoplayEnabled) return true;
      return getAutoplayRotationsInView() < 1;
    };

    const recordAutoplayRotation = () => {
      if (!rotateOnceInViewport || !autoplayEnabled) return;
      slideContainer.dataset.autoplayRotationsInView = String(getAutoplayRotationsInView() + 1);
    };

    let hoverPaused = false;
    let interactionPaused = false;

    const syncAutoplayPauseDataset = () => {
      if (!pauseAutoplayOnInteraction) {
        slideContainer.dataset.autoplayPaused = 'false';
        return;
      }
      slideContainer.dataset.autoplayPaused =
        hoverPaused || interactionPaused ? 'true' : 'false';
    };

    const clearAutoplayState = () => {
      clearAuto();
      if (typeof videoEndCleanup === 'function') {
        videoEndCleanup();
        videoEndCleanup = null;
      }
    };

    const clearAutoplayTimersOnly = () => {
      clearAuto();
    };

    const isAutoplayBlocked = () =>
      pauseAutoplayOnInteraction && (hoverPaused || interactionPaused);

    const isInteractionPaused = () =>
      pauseAutoplayOnInteraction && interactionPaused;

    const isVideoAdvanceBlocked = () => !canAutoplayRotate();

    const pauseAutoplayFromUser = () => {
      if (!pauseAutoplayOnInteraction) return;
      interactionPaused = true;
      syncAutoplayPauseDataset();
      clearAutoplayState();
    };

    const setHoverPaused = (paused) => {
      if (!pauseAutoplayOnInteraction) return;
      hoverPaused = paused;
      syncAutoplayPauseDataset();
      if (hoverPaused) {
        if (isImageBanner && advanceOnVideoEnd) {
          clearAutoplayTimersOnly();
        } else {
          clearAutoplayState();
        }
      } else if (inView && !interactionPaused) {
        scheduleNext();
      }
    };

    const resetInteractionPauseState = () => {
      hoverPaused = false;
      interactionPaused = false;
      syncAutoplayPauseDataset();
    };

    // Disable native theme autoplay for this slider to avoid double timers and offscreen rotation
    try { slideContainer.setAttribute('data-autoplay', 'false'); } catch (e) {}
    const hostEl = slideContainer.closest('slideshow-component');
    if (hostEl) {
      try { hostEl.pause && hostEl.pause(); } catch (e) {}
      try { clearInterval(hostEl.autoplay); } catch (e) {}
      try {
        hostEl.play = function() {};
        hostEl.setAutoPlay = function() {};
      } catch (e) {}
    }

    let autoTimer = null;
    let videoEndCleanup = null; // function to detach listeners when leaving video slide
    let inView = false; // autoplay gating: only rotate when the section is in viewport

    const clearAuto = () => {
      if (autoTimer) {
        clearTimeout(autoTimer);
        autoTimer = null;
      }
    };

    const getVideosInSlide = (slideEl) => {
      if (!slideEl) return [];
      return Array.from(slideEl.querySelectorAll('video'));
    };

    const getVisibleVideosInSlide = (slideEl) => {
      const all = getVideosInSlide(slideEl);
      return all.filter((v) => {
        const style = window.getComputedStyle(v);
        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0) return false;
        const parent = v.closest('.slideshow__slide_media_mob, .slideshow__slide_media_desc, .video-mobile-only, .video-desktop');
        if (parent) {
          const parentStyle = window.getComputedStyle(parent);
          if (parentStyle.display === 'none' || parentStyle.visibility === 'hidden' || parseFloat(parentStyle.opacity || '1') === 0) {
            return false;
          }
        }
        const rect = v.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && document.body.contains(v);
      });
    };

    const getVideosForViewport = (slideEl) => {
      const visible = getVisibleVideosInSlide(slideEl);
      if (visible.length > 0) return visible;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const mobileVideo = slideEl?.querySelector('.video-mobile-only video, .slideshow__slide_media_mob video');
      const desktopVideo = slideEl?.querySelector('.video-desktop video, .slideshow__slide_media_desc video');
      if (isMobile && mobileVideo) return [mobileVideo];
      if (!isMobile && desktopVideo) return [desktopVideo];
      return getVideosInSlide(slideEl).slice(0, 1);
    };

    const slideHasVisibleVideos = (slideEl) => getVideosForViewport(slideEl).length > 0;

    const enableVideoLoop = (video) => {
      if (!video) return;
      try {
        video.loop = true;
        video.setAttribute('loop', '');
      } catch (e) {}
    };

    const playVideos = (slideEl, restart = false) => {
      const vids = getVideosForViewport(slideEl);
      if (isImageBanner) {
        const hiddenVids = getVideosInSlide(slideEl).filter((v) => !vids.includes(v));
        hiddenVids.forEach((v) => {
          try { v.pause(); } catch (e) {}
        });
      }

      // Debounce forced restarts to avoid double-restart on manual navigation (image banner only)
      if (isImageBanner) {
        const now = Date.now();
        const lastTs = parseInt(slideEl?.dataset?.lastVideoStartTs || '0', 10);
        const restartDebounced = restart && (now - lastTs) > 1200;
        try { slideEl.dataset.lastVideoStartTs = String(now); } catch (e) {}

        vids.forEach((v) => {
          if (advanceOnVideoEnd) {
            try { v.loop = false; } catch (e) {}
            try { v.removeAttribute('loop'); } catch (e) {}
          } else {
            enableVideoLoop(v);
          }
          try {
            let shouldRestart = restartDebounced;
            if (shouldRestart) {
              try {
                if (!isNaN(v.currentTime) && v.currentTime > 0.3 && v.paused === false) {
                  shouldRestart = false;
                }
              } catch (e) {}
            }
            if (shouldRestart) {
              if (!isNaN(v.currentTime)) v.currentTime = 0;
            }
            const p = v.play();
            if (p && typeof p.catch === 'function') {
              p.catch(() => {/* autoplay may be blocked if unmuted; ignore */});
            }
          } catch (e) {}
        });
      } else {
        // Video slideshow - simpler restart logic
        vids.forEach((v) => {
          if (advanceOnVideoEnd) {
            try { v.loop = false; } catch (e) {}
            try { v.removeAttribute('loop'); } catch (e) {}
          } else {
            enableVideoLoop(v);
          }
          try {
            if (restart) {
              if (!isNaN(v.currentTime)) v.currentTime = 0;
            }
            const p = v.play();
            if (p && typeof p.catch === 'function') {
              p.catch(() => {/* autoplay may be blocked if unmuted; ignore */});
            }
          } catch (e) {}
        });
      }
    };

    const pauseVideos = (slideEl) => {
      const vids = getVideosInSlide(slideEl);
      vids.forEach((v) => {
        try { v.pause(); } catch (e) {}
      });
    };

    // Ensure videos in a slide are muted and reset sound UI buttons (image banner only)
    const muteVideosAndResetUI = (slideEl) => {
      if (!isImageBanner || !slideEl) return;
      const vids = getVideosInSlide(slideEl);
      vids.forEach((v) => {
        try {
          v.muted = true;
          v.volume = 0;
        } catch (e) {}
      });
      // Reset sound buttons: show .sound-on (meaning "click to unmute"), hide .sound-off
      try {
        const btnWrap = slideEl.querySelector('.slideshow-video__btns');
        if (btnWrap) {
          const on = btnWrap.querySelector('.sound-on');
          const off = btnWrap.querySelector('.sound-off');
          if (on) on.style.display = 'block';
          if (off) off.style.display = 'none';
        }
      } catch (e) {}
    };

    // Pagination (dots)
    const dots = [];
    let dotsWrapper = null;

    const buildPagination = () => {
      if (!paginationEnabled) return;
      if (slides.length < 2) return;
      if (dotsWrapper) return; // already built
      dotsWrapper = document.createElement('div');
      dotsWrapper.className = 'slideshow-pagination';
      dotsWrapper.setAttribute('role', 'navigation');
      dotsWrapper.setAttribute('aria-label', 'Slideshow pagination');
      slides.forEach((slide, idx) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slideshow-dot';
        btn.setAttribute('aria-label', `Go to slide ${idx + 1}`);
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(idx);
        });
        dots.push(btn);
        dotsWrapper.appendChild(btn);
      });
      // Place after slide container
      try {
        slideContainer.parentNode.insertBefore(dotsWrapper, slideContainer.nextSibling);
      } catch (e) {
        // Fallback: append to slider root or container
        if (isImageBanner) {
          slider.appendChild(dotsWrapper);
        } else {
          slideContainer.appendChild(dotsWrapper);
        }
      }
    };

    const updateDots = (activeIndex) => {
      if (!dots || dots.length === 0) return;
      dots.forEach((btn, i) => {
        if (i === activeIndex) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-current', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.removeAttribute('aria-current');
        }
      });
    };

    const checkActiveSlideVideoEnded = () => {
      if (!advanceOnVideoEnd || !inView || slides.length < 2) return;
      const slideEl = slides[currentIndex];
      if (!slideHasVisibleVideos(slideEl)) return;

      const videos = getVideosForViewport(slideEl);
      if (videos.length === 0) return;

      const allEnded = videos.every((v) =>
        v.ended || (Number.isFinite(v.duration) && v.duration > 0 && v.currentTime >= v.duration - 0.1)
      );
      if (!allEnded) return;

      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex, { fromVideoEnd: true });
    };

    const goToSlide = (index, options = {}) => {
      if (
        !options.fromAutoplay &&
        !options.fromVideoEnd &&
        !options.fromScheduledAdvance &&
        isImageBanner &&
        advanceOnVideoEnd &&
        pauseAutoplayOnInteraction
      ) {
        interactionPaused = false;
        hoverPaused = false;
        syncAutoplayPauseDataset();
      }

      if (options.fromVideoEnd) {
        if (isVideoAdvanceBlocked()) return;
      } else if (options.fromAutoplay) {
        if (!canAutoplayRotate() || isAutoplayBlocked()) return;
      } else if (options.fromScheduledAdvance) {
        if (autoplayEnabled && rotateOnceInViewport && !canAutoplayRotate()) return;
      }

      // Pause videos on the current slide before leaving
      try { pauseVideos(slides[currentIndex]); } catch(e) {}

      // leaving current slide: cleanup any video listeners
      if (typeof videoEndCleanup === 'function') {
        videoEndCleanup();
        videoEndCleanup = null;
      }

      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      const offset = slides[targetIndex].offsetLeft;

      // Lock scroll handler and disable snap during smooth programmatic navigation
      if (navLockTimeout) { clearTimeout(navLockTimeout); navLockTimeout = null; }
      navLockActive = true;
      navLockTarget = targetIndex;
      slideContainer.style.scrollSnapType = 'none'; // Disable snap to prevent fighting scrollTo

      navLockTimeout = setTimeout(() => {
        navLockActive = false;
        navLockTarget = -1;
        navLockTimeout = null;
        if (!isDragging) slideContainer.style.scrollSnapType = ''; // Restore snap after animation
      }, 800); // 800ms gives enough time for the smooth scroll to complete

      slideContainer.scrollTo({
        left: offset,
        behavior: 'smooth'
      });

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === targetIndex);
        slide.setAttribute('tabindex', i === targetIndex ? '0' : '-1');
      });

      currentIndex = targetIndex;

      if (options.fromAutoplay) {
        recordAutoplayRotation();
      }

      updateDots(currentIndex);

      // Ensure videos in the target slide start muted and UI reset (image banner only)
      if (isImageBanner) {
        muteVideosAndResetUI(slides[currentIndex]);
      }

      // Play videos on any slide that has them (including first slide)
      if (slideHasVisibleVideos(slides[currentIndex])) {
        playVideos(slides[currentIndex], true);
      }

      // after navigation, reschedule autoplay if needed
      if (!options.fromAutoplay && !options.fromVideoEnd && pauseAutoplayOnInteraction) {
        if (isImageBanner && advanceOnVideoEnd) {
          clearAutoplayTimersOnly();
          scheduleNext();
        } else {
          pauseAutoplayFromUser();
        }
      } else {
        scheduleNext();
      }

      if (advanceOnVideoEnd && slideHasVisibleVideos(slides[currentIndex])) {
        requestAnimationFrame(checkActiveSlideVideoEnded);
      }
    };

    const scheduleNext = () => {
      clearAuto();
      if (typeof videoEndCleanup === 'function') {
        videoEndCleanup();
        videoEndCleanup = null;
      }
      // Only schedule when the slider is in view
      if (!inView) return;
      if (slides.length < 2) return;
      if (!(isImageBanner && advanceOnVideoEnd) && isAutoplayBlocked()) {
        return;
      }

      const slideEl = slides[currentIndex];
      const nextIndex = (currentIndex + 1) % slides.length;

      const waitForVideoEndThenAdvance = (targetIndex) => {
        const videos = getVideosForViewport(slideEl);
        if (videos.length === 0) return false;

        playVideos(slideEl, false);
        const handlers = [];
        let fired = false;

        const finish = () => {
          if (fired) return;
          fired = true;
          goToSlide(targetIndex, { fromVideoEnd: true });
        };

        videos.forEach((v) => {
          if (v.ended || (Number.isFinite(v.duration) && v.duration > 0 && v.currentTime >= v.duration - 0.1)) {
            finish();
            return;
          }

          const onEnded = () => finish();
          const onError = () => finish();
          const onStall = () => finish();
          v.addEventListener('ended', onEnded, { once: true });
          v.addEventListener('error', onError, { once: true });
          v.addEventListener('stalled', onStall, { once: true });
          handlers.push(() => {
            v.removeEventListener('ended', onEnded);
            v.removeEventListener('error', onError);
            v.removeEventListener('stalled', onStall);
          });
        });

        videoEndCleanup = () => {
          handlers.forEach((fn) => fn());
          clearAuto();
        };
        return true;
      };

      // Video slideshow: advance when the active video finishes (no loop)
      if (!isImageBanner && advanceOnVideoEnd) {
        if (waitForVideoEndThenAdvance(nextIndex)) return;
      }

      // Main banner: image slides use duration timer; video slides use stable ended listeners
      if (isImageBanner && advanceOnVideoEnd) {
        if (slideHasVisibleVideos(slideEl)) {
          playVideos(slideEl, false);
          return;
        }

        if (isInteractionPaused()) return;

        autoTimer = setTimeout(() => {
          goToSlide(nextIndex, { fromScheduledAdvance: true });
        }, speedMs);
        return;
      }

      if (!autoplayEnabled) return;
      if (!canAutoplayRotate()) return;

      // Legacy: second slide with non-looping video — wait for video end, then go to first slide
      if (isImageBanner && !advanceOnVideoEnd && currentIndex === 1) {
        const videos = getVisibleVideosInSlide(slideEl);
        const hasNonLoopingVideos = videos.length > 0 && videos.some((v) => !v.loop);
        if (hasNonLoopingVideos) {
          // ensure videos are playing (do not force restart here; restart happens on enter)
          playVideos(slideEl, false);
          if (waitForVideoEndThenAdvance(0)) return;
        }

        if (videos.length > 0) {
          playVideos(slideEl, false);
        }
      }

      // Default rotation: go to next slide after speedMs
      autoTimer = setTimeout(() => {
        const nextIndex = (currentIndex + 1) % slides.length;
        goToSlide(nextIndex, { fromAutoplay: true });
      }, speedMs);
    };

    const getClosestIndexToCenter = () => {
      const containerCenter = slideContainer.scrollLeft + (slideContainer.clientWidth / 2);
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        const distance = Math.abs(slideCenter - containerCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    let scrollRaf = null;
    slideContainer.addEventListener('scroll', function() {
      // Ignore scroll events during drag operations
      if (isDragging) return;

      if (!scrollRaf) {
        scrollRaf = requestAnimationFrame(() => {
          scrollRaf = null;
          try {
            updateDots(getClosestIndexToCenter());
          } catch (e) {}
        });
      }

      // If we're in the middle of a programmatic smooth scroll, ignore intermediate scroll events
      if (navLockActive) {
        const targetSlide = slides[navLockTarget];
        if (targetSlide) {
          const targetOffset = targetSlide.offsetLeft;
          if (Math.abs(slideContainer.scrollLeft - targetOffset) <= 2) {
            // Arrived at target — release the lock
            navLockActive = false;
            navLockTarget = -1;
            if (navLockTimeout) { clearTimeout(navLockTimeout); navLockTimeout = null; }
          } else {
            return;
          }
        } else {
          // If target missing, release lock defensively
          navLockActive = false;
          navLockTarget = -1;
          if (navLockTimeout) { clearTimeout(navLockTimeout); navLockTimeout = null; }
        }
      }

      clearTimeout(isScrolling);
      isScrolling = setTimeout(function() {
        let scrollLeft = slideContainer.scrollLeft;
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== currentIndex) {
          const prevIndex = currentIndex;

          // Pause videos on the previous slide and cleanup any video listeners
          try { pauseVideos(slides[prevIndex]); } catch(e) {}
          if (typeof videoEndCleanup === 'function') {
            videoEndCleanup();
            videoEndCleanup = null;
          }

          currentIndex = closestIndex;
          slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === closestIndex);
            slide.setAttribute('tabindex', i === closestIndex ? '0' : '-1');
          });

          updateDots(currentIndex);

          // Ensure the new slide starts muted and UI reset (image banner only)
          if (isImageBanner) {
            muteVideosAndResetUI(slides[currentIndex]);
          }

          // Play videos on any slide that has them (including first slide)
          if (slideHasVisibleVideos(slides[currentIndex])) {
            playVideos(slides[currentIndex], true);
          }

          scheduleNext();
          requestAnimationFrame(checkActiveSlideVideoEnded);
        }
      }, 100);
    }, { passive: true });

    const navigateFromTarget = (eventTarget, e) => {
      if (!eventTarget || typeof eventTarget.closest !== 'function') return false;

      const nativeCta = eventTarget.closest('.main-banner__cta');
      if (nativeCta) return false;

      const clickedButton = eventTarget.closest('[data-button-url]');
      if (clickedButton) {
        const buttonUrl = clickedButton.getAttribute('data-button-url');
        if (buttonUrl && buttonUrl.trim() !== '') {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          window.location.href = buttonUrl;
          return true;
        }
        return false;
      }

      // Keep native interactions for slider controls, CTAs, and media controls.
      if (
        eventTarget.closest('.main-banner__audio-control') ||
        eventTarget.closest('.video-slideshow__button') ||
        eventTarget.closest('.video-slideshow__button-wrapper a') ||
        eventTarget.closest('.slider-button') ||
        eventTarget.closest('.slideshow__autoplay') ||
        eventTarget.closest('button[aria-controls]')
      ) {
        return false;
      }

      const slide = eventTarget.closest(isImageBanner ? '.custom-slideshow__slide' : '.slideshow__slide');
      if (!slide) return false;

      const wrapper = slide.querySelector('.slide-link-wrapper');
      if (!wrapper) return false;

      const bannerUrl = wrapper.getAttribute('data-url');
      if (!bannerUrl || bannerUrl.trim() === '') return false;

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      window.location.href = bannerUrl;
      return true;
    };

    const bindBannerButtonLinks = () => {
      slideContainer.querySelectorAll('[data-button-url]').forEach((btn) => {
        if (btn.dataset.bannerButtonBound === 'true') return;
        btn.dataset.bannerButtonBound = 'true';

        btn.addEventListener('click', (e) => {
          if (hasDragged || Date.now() < suppressClicksUntil) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          pauseAutoplayFromUser();

          if (btn.tagName === 'A' && btn.getAttribute('href')) return;

          const url = btn.getAttribute('data-button-url');
          if (!url || url.trim() === '') return;

          e.preventDefault();
          e.stopPropagation();
          tapNavigationAllowed = true;
          window.location.href = url;
        }, true);
      });
    };

    if (isImageBanner) {
      bindBannerButtonLinks();
    }

    const slideSelector = isImageBanner ? '.custom-slideshow__slide' : '.slideshow__slide';
    const slideLinkInteractiveSelector =
      '[data-button-url], .main-banner__cta, .main-banner__audio-control, .video-slideshow__button, .video-slideshow__button-wrapper a, .slider-button, .slideshow__autoplay, button[aria-controls], .slider-counter__link';

    const bindSlideLinkClicks = () => {
      if (slideContainer.dataset.slideLinksBound === 'true') return;
      slideContainer.dataset.slideLinksBound = 'true';

      slideContainer.addEventListener(
        'click',
        (e) => {
          if (e.target.closest(slideLinkInteractiveSelector)) return;

          const slide = e.target.closest(slideSelector);
          if (!slide) return;

          const wrapper = slide.querySelector('.slide-link-wrapper');
          if (!wrapper) return;

          const url = wrapper.getAttribute('data-url');
          if (!url || url.trim() === '') return;

          pauseAutoplayFromUser();
          e.preventDefault();
          e.stopPropagation();
          window.location.href = url;
        },
        true
      );
    };

    // Single-slide sliders skip drag handlers; bind direct click-to-navigate instead.
    if (!enableDragSwipe) {
      bindSlideLinkClicks();
    }

    // Unified drag/swipe functionality for both desktop and mobile (only if more than 1 slide)
    if (enableDragSwipe) {
      const pointerEventsSupported = typeof window !== 'undefined' && 'PointerEvent' in window;
      const nonDragSelector =
        'input, textarea, select, [contenteditable="true"], [data-button-url], .main-banner__cta, .main-banner__audio-control, .video-slideshow__button, .video-slideshow__button-wrapper a, a, button';
      const minSwipeCommitPxTouch = 40;

      const endGestureQualifiesSwipe = (absDeltaX, absDeltaY) => {
        if (dragAxis !== 'x' || !hasDragged) return false;
        // suppressTapNavigation only blocks link clicks after drag, not slide changes
        if (isVerticalScroll || pageScrolledDuringGesture()) return false;
        const isFlick = Math.abs(velocity) > 0.45;
        const minCommitPx = isTouchDevice ? minSwipeCommitPxTouch : 30;
        return absDeltaX > absDeltaY && (absDeltaX > minCommitPx || (isFlick && absDeltaX > 15));
      };

      const resolveSlideWrapper = (target) => {
        if (!target || typeof target.closest !== 'function') return null;

        const wrapper = target.closest('.slide-link-wrapper');
        if (wrapper) return wrapper;

        const slide = target.closest(isImageBanner ? '.custom-slideshow__slide' : '.slideshow__slide');
        if (!slide) return null;
        return slide.querySelector('.slide-link-wrapper');
      };

      const setDraggingStyles = (dragging) => {
        slideContainer.style.cursor = dragging ? 'grabbing' : 'grab';
        slideContainer.style.userSelect = dragging ? 'none' : '';
        slideContainer.style.scrollBehavior = dragging ? 'auto' : 'smooth';
        if (dragging) {
          slideContainer.style.scrollSnapType = 'none';
        } else if (!navLockActive) {
          slideContainer.style.scrollSnapType = '';
        }
      };

      const resetDragState = (restoreStyles = true) => {
        isDragging = false;
        dragAxis = null;
        activePointerId = null;
        velocity = 0;
        totalMovement = 0;
        currentSlideWrapper = null;
        dragStartTarget = null;
        lastPointerX = 0;
        lastPointerTime = 0;
        if (restoreStyles) setDraggingStyles(false);
      };

      const markVerticalScrollIntent = () => {
        isVerticalScroll = true;
        suppressTapNavigation = true;
        tapNavigationAllowed = false;
      };

      const clearVerticalScrollIntent = () => {
        isVerticalScroll = false;
        if (!hasDragged && Date.now() >= suppressClicksUntil) {
          suppressTapNavigation = false;
        }
      };

      const restoreStylesAfterRelease = () => {
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(() => setDraggingStyles(false));
          return;
        }
        setTimeout(() => setDraggingStyles(false), 0);
      };

      const deferHasDraggedReset = () => {
        if (hasDragged) {
          setTimeout(() => { hasDragged = false; }, GHOST_CLICK_SUPPRESS_MS);
        } else {
          hasDragged = false;
        }
      };

      const handleTapNavigation = (eventTarget, e) => {
        if (shouldBlockBannerNavigation()) return false;
        const navigated = navigateFromTarget(eventTarget, e);
        if (navigated) {
          tapNavigationAllowed = true;
        }
        return navigated;
      };

      const handleStart = (e) => {
        if (activePointerId !== null) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (!e.isPrimary) return;

        const target = e.target;
        if (target && typeof target.closest === 'function' && target.closest(nonDragSelector)) {
          return;
        }

        isTouchDevice = e.pointerType === 'touch';
        isDragging = true;
        hasDragged = false;
        clearVerticalScrollIntent();
        recordGestureStart();
        dragAxis = null;
        activePointerId = e.pointerId;
        dragStartTarget = target || null;
        totalMovement = 0;
        velocity = 0;

        startX = e.clientX;
        startY = e.clientY;
        startScrollLeft = slideContainer.scrollLeft;
        lastPointerX = e.clientX;
        lastPointerTime = Date.now();

        currentSlideWrapper = resolveSlideWrapper(target);

        // Avoid auto-rotation while the user is holding/dragging the slider.
        if (isImageBanner && advanceOnVideoEnd) {
          clearAutoplayTimersOnly();
        } else {
          pauseAutoplayFromUser();
        }

        setDraggingStyles(true);

        try { slideContainer.setPointerCapture(e.pointerId); } catch (_) {}
      };

      const handleMove = (e) => {
        if (!isDragging || activePointerId !== e.pointerId) return;

        const deltaXFromStart = e.clientX - startX;
        const deltaYFromStart = e.clientY - startY;
        const absDeltaX = Math.abs(deltaXFromStart);
        const absDeltaY = Math.abs(deltaYFromStart);

        totalMovement = Math.sqrt(deltaXFromStart * deltaXFromStart + deltaYFromStart * deltaYFromStart);

        if (!dragAxis) {
          if (absDeltaX > AXIS_LOCK_THRESHOLD || absDeltaY > AXIS_LOCK_THRESHOLD) {
            dragAxis = absDeltaX > absDeltaY ? 'x' : 'y';
            hasDragged = dragAxis === 'x';
            if (hasDragged) {
              suppressClicksBriefly();
            }
          } else {
            return;
          }
        }

        if (dragAxis === 'y') {
          markVerticalScrollIntent();
          try { slideContainer.releasePointerCapture(e.pointerId); } catch (_) {}
          resetDragState();
          clearVerticalScrollIntent();
          return;
        }

        if (dragAxis !== 'x') return;

        const now = Date.now();
        const dt = now - lastPointerTime;
        if (dt > 0 && dt < 80) {
          velocity = (e.clientX - lastPointerX) / dt;
        }

        lastPointerX = e.clientX;
        lastPointerTime = now;

        slideContainer.scrollLeft = startScrollLeft - deltaXFromStart;
        e.preventDefault();
      };

      const handleEnd = (e) => {
        if (pageScrolledDuringGesture()) {
          suppressTapNavigation = true;
        }

        if (activePointerId !== e.pointerId) {
          clearVerticalScrollIntent();
          clearGestureState();
          return;
        }
        if (!isDragging) {
          resetDragState();
          clearVerticalScrollIntent();
          clearGestureState();
          return;
        }

        const deltaX = startX - e.clientX;
        const deltaY = startY - e.clientY;
        const absDeltaX = Math.abs(deltaX);
        const absDeltaY = Math.abs(deltaY);
        const isClick = qualifiesAsTap(totalMovement);

        if (pageScrolledDuringGesture()) {
          suppressTapNavigation = true;
        }

        const hasHorizontalDrag = endGestureQualifiesSwipe(absDeltaX, absDeltaY);
        let targetIndex = null;

        if (hasHorizontalDrag) {
          e.preventDefault();
          e.stopPropagation();
          suppressClicksBriefly();

          targetIndex = deltaX > 0
            ? (currentIndex + 1) % slides.length
            : (currentIndex - 1 + slides.length) % slides.length;
        } else if (isClick) {
          handleTapNavigation(dragStartTarget, e);
        } else if (isDragging && hasDragged) {
          suppressClicksBriefly();
          // If dragged but not enough force/distance, snap back to current slide
          targetIndex = currentIndex;
        }

        if (targetIndex !== null) {
          goToSlide(targetIndex);
        }

        resetDragState(false);
        restoreStylesAfterRelease();
        if (targetIndex === null) {
          if (isImageBanner && advanceOnVideoEnd) {
            scheduleNext();
          } else if (!isAutoplayBlocked()) {
            scheduleNext();
          }
        }
        deferHasDraggedReset();
        clearVerticalScrollIntent();
        clearGestureState();
      };

      const handleCancel = (e) => {
        // Safari can emit lostpointercapture during a long press while the pointer is still down.
        // Ignore that transient state and wait for pointerup/pointercancel.
        if (e && e.type === 'lostpointercapture' && typeof e.buttons === 'number' && e.buttons !== 0) {
          return;
        }
        if (!isDragging && activePointerId === null) return;
        if (activePointerId !== null && e && typeof e.pointerId === 'number' && activePointerId !== e.pointerId) {
          return;
        }

        const shouldSnapBack = isDragging && dragAxis === 'x' && hasDragged;
        setDraggingStyles(false);

        if (shouldSnapBack) {
          suppressClicksBriefly();
          const deltaX = startX - lastPointerX;
          const absDeltaX = Math.abs(deltaX);

          if (absDeltaX > 40) {
            const targetIndex = deltaX > 0
              ? (currentIndex + 1) % slides.length
              : (currentIndex - 1 + slides.length) % slides.length;
            goToSlide(targetIndex);
          } else {
            goToSlide(currentIndex);
          }
        }

        resetDragState();
        hasDragged = false;
        clearVerticalScrollIntent();
        clearGestureState();
        if (isImageBanner && advanceOnVideoEnd) {
          scheduleNext();
        } else if (!isAutoplayBlocked()) {
          scheduleNext();
        }
      };

      // Allow native touch panning (vertical) but handle horizontal with JS.
      slideContainer.style.touchAction = 'pan-y';
      slideContainer.style.cursor = 'grab';

      if (pointerEventsSupported) {
        slideContainer.addEventListener('pointerdown', handleStart);
        slideContainer.addEventListener('pointermove', handleMove, { passive: false });
        slideContainer.addEventListener('pointerup', handleEnd);
        slideContainer.addEventListener('pointercancel', handleCancel);
        slideContainer.addEventListener('lostpointercapture', handleCancel);
      }

      // Fallback touch handlers for Safari which may not fire pointer events consistently
      slideContainer.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1 && activePointerId === null) {
          const touch = e.touches[0];
          const target = touch.target;
          if (target && typeof target.closest === 'function' && target.closest(nonDragSelector)) {
            return;
          }

          isTouchDevice = true;
          isDragging = true;
          hasDragged = false;
          clearVerticalScrollIntent();
          recordGestureStart();
          dragAxis = null;
          activePointerId = touch.identifier;
          dragStartTarget = target || null;
          totalMovement = 0;
          velocity = 0;

          startX = touch.clientX;
          startY = touch.clientY;
          startScrollLeft = slideContainer.scrollLeft;
          lastPointerX = touch.clientX;
          lastPointerTime = Date.now();

          currentSlideWrapper = resolveSlideWrapper(target);

          if (isImageBanner && advanceOnVideoEnd) {
            clearAutoplayTimersOnly();
          } else {
            pauseAutoplayFromUser();
          }

          setDraggingStyles(true);
        }
      }, { passive: false });

      slideContainer.addEventListener('touchmove', (e) => {
        if (!isDragging || activePointerId === null) return;
        
        let touch = null;
        for (let i = 0; i < e.changedTouches.length; i++) {
          if (e.changedTouches[i].identifier === activePointerId) {
            touch = e.changedTouches[i];
            break;
          }
        }
        if (!touch) return;

        const deltaXFromStart = touch.clientX - startX;
        const deltaYFromStart = touch.clientY - startY;
        const absDeltaX = Math.abs(deltaXFromStart);
        const absDeltaY = Math.abs(deltaYFromStart);

        totalMovement = Math.sqrt(deltaXFromStart * deltaXFromStart + deltaYFromStart * deltaYFromStart);

        if (!dragAxis) {
          if (absDeltaX > AXIS_LOCK_THRESHOLD || absDeltaY > AXIS_LOCK_THRESHOLD) {
            dragAxis = absDeltaX > absDeltaY ? 'x' : 'y';
            hasDragged = dragAxis === 'x';
            if (hasDragged) {
              suppressClicksBriefly();
            }
          } else {
            return;
          }
        }

        if (dragAxis === 'y') {
          markVerticalScrollIntent();
          resetDragState();
          clearVerticalScrollIntent();
          return;
        }

        if (dragAxis !== 'x') return;

        const now = Date.now();
        const dt = now - lastPointerTime;
        if (dt > 0 && dt < 80) {
          velocity = (touch.clientX - lastPointerX) / dt;
        }

        lastPointerX = touch.clientX;
        lastPointerTime = now;

        slideContainer.scrollLeft = startScrollLeft - deltaXFromStart;
        e.preventDefault();
      }, { passive: false });

      slideContainer.addEventListener('touchend', (e) => {
        if (pageScrolledDuringGesture()) {
          suppressTapNavigation = true;
        }

        if (!isDragging || activePointerId === null) {
          clearVerticalScrollIntent();
          return;
        }

        let touch = null;
        for (let i = 0; i < e.changedTouches.length; i++) {
          if (e.changedTouches[i].identifier === activePointerId) {
            touch = e.changedTouches[i];
            break;
          }
        }
        if (!touch) return;

        const deltaX = startX - touch.clientX;
        const deltaY = startY - touch.clientY;
        const absDeltaX = Math.abs(deltaX);
        const absDeltaY = Math.abs(deltaY);
        const isClick = qualifiesAsTap(totalMovement);

        if (pageScrolledDuringGesture()) {
          suppressTapNavigation = true;
        }

        const hasHorizontalDrag = endGestureQualifiesSwipe(absDeltaX, absDeltaY);
        let targetIndex = null;

        if (hasHorizontalDrag) {
          e.preventDefault();
          e.stopPropagation();
          suppressClicksBriefly();

          targetIndex = deltaX > 0
            ? (currentIndex + 1) % slides.length
            : (currentIndex - 1 + slides.length) % slides.length;
        } else if (isClick) {
          handleTapNavigation(dragStartTarget, e);
        } else if (isDragging && hasDragged) {
          suppressClicksBriefly();
          // If dragged but not enough force/distance, snap back to current slide
          targetIndex = currentIndex;
        }

        if (targetIndex !== null) {
          goToSlide(targetIndex);
        }

        resetDragState(false);
        restoreStylesAfterRelease();
        if (targetIndex === null) {
          if (isImageBanner && advanceOnVideoEnd) {
            scheduleNext();
          } else if (!isAutoplayBlocked()) {
            scheduleNext();
          }
        }
        deferHasDraggedReset();
        clearVerticalScrollIntent();
        clearGestureState();
      }, { passive: false });

      slideContainer.addEventListener('touchcancel', (e) => {
        if (!isDragging) return;

        const shouldSnapBack = isDragging && dragAxis === 'x' && hasDragged;
        setDraggingStyles(false);

        if (shouldSnapBack) {
          suppressClicksBriefly();
          const deltaX = startX - lastPointerX;
          const absDeltaX = Math.abs(deltaX);

          if (absDeltaX > 40) {
            const targetIndex = deltaX > 0
              ? (currentIndex + 1) % slides.length
              : (currentIndex - 1 + slides.length) % slides.length;
            goToSlide(targetIndex);
          } else {
            goToSlide(currentIndex);
          }
        }

        resetDragState();
        hasDragged = false;
        clearVerticalScrollIntent();
        clearGestureState();
        scheduleNext();
      }, { passive: false });

      // Navigate on intentional clicks; block synthetic clicks after drag/swipe gestures.
      slideContainer.addEventListener('click', (e) => {
        if (e.target.closest('[data-button-url], .main-banner__cta')) return;

        if (shouldBlockBannerNavigation()) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        // Already navigated via pointer/touch gesture handler.
        if (tapNavigationAllowed) {
          tapNavigationAllowed = false;
          return;
        }

        handleTapNavigation(e.target, e);
      }, true);

      // Native touchmove to prevent iOS Safari from hijacking the swipe into a native page scroll if we are already locked sideways.
      slideContainer.addEventListener('touchmove', (e) => {
        if (isDragging && dragAxis === 'x') {
          e.preventDefault();
        }
      }, { passive: false });

      // Prevent native image/link drag ghosts that are especially disruptive in Safari.
      slideContainer.addEventListener('dragstart', (e) => {
        e.preventDefault();
      });

      // Avoid long-press context menu after a drag gesture.
      slideContainer.addEventListener('contextmenu', (e) => {
        if (isDragging || hasDragged) {
          e.preventDefault();
        }
      });

      // Prevent link clicks if user was dragging
      const links = slideContainer.querySelectorAll('a');
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        link.addEventListener('touchend', (e) => {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      });

    }

    const advanceVideoEndBound = new WeakSet();
    let videoAdvanceLock = false;

    const handleVideoEndedForAdvance = (video) => {
      if (videoAdvanceLock) return;

      const slideEl = video.closest(isImageBanner ? '.custom-slideshow__slide' : '.slideshow__slide');
      if (!slideEl || !advanceOnVideoEnd || !inView) return;

      const slideIndex = Array.from(slides).indexOf(slideEl);
      if (slideIndex !== currentIndex) return;

      const visibleVideos = getVideosForViewport(slideEl);
      if (!visibleVideos.includes(video)) return;
      if (isVideoAdvanceBlocked()) return;

      videoAdvanceLock = true;
      const nextIndex = (currentIndex + 1) % slides.length;
      goToSlide(nextIndex, { fromVideoEnd: true });
      setTimeout(() => {
        videoAdvanceLock = false;
      }, 800);
    };

    const bindAdvanceOnVideoEndListeners = () => {
      if (!advanceOnVideoEnd) return;

      slides.forEach((slideEl) => {
        getVideosInSlide(slideEl).forEach((video) => {
          if (advanceVideoEndBound.has(video)) return;
          advanceVideoEndBound.add(video);

          video.addEventListener('ended', () => handleVideoEndedForAdvance(video));

          video.addEventListener('timeupdate', function onTimeUpdate() {
            if (!Number.isFinite(video.duration) || video.duration <= 0) return;
            if (video.currentTime < video.duration - 0.2) return;
            video.removeEventListener('timeupdate', onTimeUpdate);
            handleVideoEndedForAdvance(video);
          });
        });
      });
    };

    bindAdvanceOnVideoEndListeners();

    // init to first slide and schedule autoplay
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === 0);
      slide.setAttribute('tabindex', i === 0 ? '0' : '-1');
    });

    // Ensure initial slide starts muted and UI reset (if it has videos) - image banner only
    if (isImageBanner) {
      muteVideosAndResetUI(slides[0]);
      if (slideHasVisibleVideos(slides[0])) {
        playVideos(slides[0], true);
      }
    } else if (advanceOnVideoEnd && slideHasVisibleVideos(slides[0])) {
      playVideos(slides[0], true);
    }

    // Build pagination and set initial active dot
    buildPagination();
    updateDots(0);

    // Scroll smoothly to first slide (in case not at start)
    slideContainer.scrollTo({ left: slides[0]?.offsetLeft || 0, behavior: 'smooth' });

    // Setup viewport observer to start/stop autoplay only when section is visible
    const applyVisibility = (visible) => {
      const wasInView = inView;
      inView = !!visible;
      if (!inView && wasInView) {
        resetAutoplayRotationsInView();
        resetInteractionPauseState();
      }
      if (inView) {
        // resume scheduling
        scheduleNext();
        // ensure video continues if the active slide has video
        if (slideHasVisibleVideos(slides[currentIndex])) {
          try { playVideos(slides[currentIndex], false); } catch(e) {}
        }
        requestAnimationFrame(checkActiveSlideVideoEnded);
      } else {
        // stop timers and detach video end listeners
        clearAuto();
        if (typeof videoEndCleanup === 'function') {
          videoEndCleanup();
          videoEndCleanup = null;
        }
        try { pauseVideos(slides[currentIndex]); } catch(e) {}
      }
    };

    // Page/tab visibility handling to ensure no timers run in background
    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearAuto();
        if (typeof videoEndCleanup === 'function') {
          videoEndCleanup();
          videoEndCleanup = null;
        }
        try { pauseVideos(slides[currentIndex]); } catch (e) {}
      } else {
        if (inView) {
          scheduleNext();
          if (slideHasVisibleVideos(slides[currentIndex])) {
            try { playVideos(slides[currentIndex], false); } catch (e) {}
          }
        }
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', () => { clearAuto(); });

    if (pauseAutoplayOnInteraction) {
      const hoverTarget = hostEl || slider;
      hoverTarget.addEventListener('mouseenter', () => setHoverPaused(true));
      hoverTarget.addEventListener('mouseleave', () => setHoverPaused(false));
      hoverTarget.addEventListener('focusin', () => pauseAutoplayFromUser());

      slideContainer.querySelectorAll('.main-banner__audio-control').forEach((btn) => {
        btn.addEventListener('click', () => pauseAutoplayFromUser(), true);
      });
    }

    syncAutoplayPauseDataset();

    const checkInitialVisibility = () => {
      const rect = slideContainer.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const vw = window.innerWidth || document.documentElement.clientWidth;
      if (rect.width <= 0 || rect.height <= 0) return;
      const visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
      const visibleWidth = Math.min(rect.right, vw) - Math.max(rect.left, 0);
      const visibleArea = Math.max(0, visibleHeight) * Math.max(0, visibleWidth);
      const totalArea = rect.width * rect.height;
      const ratio = totalArea > 0 ? visibleArea / totalArea : 0;
      const visible = rect.bottom > 0 && rect.top < vh && rect.right > 0 && rect.left < vw && ratio >= visibleThreshold;
      applyVisibility(visible);
    };

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          applyVisibility(entry.isIntersecting && entry.intersectionRatio >= visibleThreshold);
        });
      }, { threshold: [0, visibleThreshold, 1] });
      io.observe(slideContainer);
      requestAnimationFrame(checkInitialVisibility);
    } else {
      // Fallback for older browsers
      const checkVisibilityFallback = () => {
        checkInitialVisibility();
      };
      window.addEventListener('scroll', checkVisibilityFallback, { passive: true });
      window.addEventListener('resize', checkVisibilityFallback);
      checkVisibilityFallback();
    }
  }
});